import Swal from "sweetalert2";
import { DocumentsSupportingOutPutCreateSupportingDocumentsApi } from "../../Apis/user/ApiConfig";
import {
    DOCUMENTS_SUPPORTING_OUTPUT_CREATE_SUCCESS,
    DOCUMENTS_SUPPORTING_OUTPUT_CREATE_ERROR,
    DOCUMENTS_SUPPORTING_OUTPUT_CREATE_REQUEST,
    CLEAR_DOCUMENTS_SUPPORTING_DATA
} from "../../Types/user/Types";


export const DocumentsSupportingOutPutCreateSuccess = (res) => {
    return {
        type: DOCUMENTS_SUPPORTING_OUTPUT_CREATE_SUCCESS,
        payload: res,
    };
};

export const DocumentsSupportingOutPutCreateError = (error) => {
    return {
        type: DOCUMENTS_SUPPORTING_OUTPUT_CREATE_ERROR,
        error: error,
    };
};

export const DocumentsSupportingOutPutCreateRequest = (res) => {
    return {
        type: DOCUMENTS_SUPPORTING_OUTPUT_CREATE_REQUEST,
        payload: res,
    };
};

export const clearDocumentsSupportingData = () => ({
    type: CLEAR_DOCUMENTS_SUPPORTING_DATA,
});

export const OutPutCreateSupportingDocumentsActionHandler = (data) => {
    return (dispatch) => {
        dispatch(DocumentsSupportingOutPutCreateRequest());
        try {
            DocumentsSupportingOutPutCreateSupportingDocumentsApi(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 201) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Output Format Successfully Created!',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            dispatch(DocumentsSupportingOutPutCreateSuccess(res?.data));
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Something went wrong!",
                                confirmButtonColor: "rgb(231,52,70)",
                            });
                            dispatch(DocumentsSupportingOutPutCreateError(res));
                        }
                    } else {
                        dispatch(DocumentsSupportingOutPutCreateError(""));
                    }
                })
                .catch((err) => {
                    dispatch(DocumentsSupportingOutPutCreateError("Something Went Wrong!!!"));
                });
        } catch (err) {
            dispatch(DocumentsSupportingOutPutCreateError(err));
        }
    };
};